export default __webpack_public_path__ + "static/media/Natas-Do-Ceu.c07b01ef.jpg";